import React from "react";
import { Text, Flex, Circle, type FlexProps } from "@chakra-ui/react";

export function Tooltip({ color, children, ...props }: { color: string } & FlexProps) {
  return (
    <Flex
      align="center"
      bg="white"
      borderRadius="md"
      boxShadow="0px 2px 12px 0px rgba(0, 0, 0, 0.08)"
      gap={{ base: 2, lg: 2.5 }}
      justify="center"
      py={1}
      px={{ base: 2, lg: 3, xl: 4 }}
      h={{ base: "32px", lg: "36px" }}
      {...props}
    >
      <Circle bg={color} size="10px" />
      <Text fontWeight="medium" fontSize={{ base: "xs", lg: "sm", xl: "md" }}>
        {children}
      </Text>
    </Flex>
  );
}
